import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';

import { SourceActions, SourceSelectors } from './source.store';
import type { Source } from '../../../types';

@Injectable({ providedIn: 'root' })
export class SourceStoreService {
  private readonly store = inject(Store);

  public getSources(): Observable<Source[]> {
    return this.store.select(SourceSelectors.entities()).pipe(filterBoolean);
  }

  public getSourcesLoading(): Observable<boolean> {
    return this.store.select(SourceSelectors.isPending());
  }

  public getSourcesFailed(): Observable<boolean> {
    return this.store.select(SourceSelectors.isFailed());
  }

  public fetchSources(): void {
    this.store.dispatch(SourceActions.fetchCollection());
  }
}
